"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_ShockShield_OnDamageDealtEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const DamageType_1 = require("../../core/enums/DamageType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Effect_ShockShield_OnDamageDealtEventHandlerScript = class Effect_ShockShield_OnDamageDealtEventHandlerScript {
    run(sequence, container, handler, event) {
        const { percent } = handler.args.scriptArgs;
        const damageAbsorption = Math.round(percent * event.args.damage.amount / 100);
        if (damageAbsorption <= 0) {
            return;
        }
        sequence = sequence.pushSequence("parallel");
        container.selectLivingTargets(event.subject, Target_1.Target.AllAllies)
            .forEach(targetId => {
            container.applyBuff({
                sequence,
                creatorId: event.subject,
                targetId,
                effect: new core_1.DamageAbsorbEffectArgs({
                    [DamageType_1.DamageType.All]: damageAbsorption
                }, damageAbsorption),
                duration: Duration_1.Duration.Permanent,
            });
        });
    }
};
Effect_ShockShield_OnDamageDealtEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_ShockShield_OnDamageDealt")
], Effect_ShockShield_OnDamageDealtEventHandlerScript);
exports.Effect_ShockShield_OnDamageDealtEventHandlerScript = Effect_ShockShield_OnDamageDealtEventHandlerScript;
